<template>
  <div>
    <div style="font-size: 22px" class="pl-4 mt-4">
      สำนักงานส่งเสริมเศรษฐกิจดิจิทัลเขตพื้นที่ภาคใต้ สาขาภาคใต้ตอนบน
    </div>
    <v-divider></v-divider>
    <div class="pa-5">
      <v-row dense>
        <v-col cols="2">
          <v-icon size="30px">mdi-map-marker-outline</v-icon>
        </v-col>
        <v-col cols="10">
          <div class="pl-0">
            ชั้น 1 อาคารศูนย์บริการวิชาการ มหาวิทยาลัยสงขลานครินทร์ สะพานหิน
            อำเภอเมือง จังหวัดภูเก็ต 83000
          </div>
          <div class="mt-4">
            <div>Tel : 0-7637-9111</div>
            <div>Fax : 0-7637-9000</div>
          </div>
          <div class="mt-4">
            <!-- <div>Email : Doss@depa.or.th</div> -->
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-6"
        style="position: relative; width: 100%; height: 0; padding-top: 100%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7904.477753456619!2d98.395939!3d7.870053999999999!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2e1b9b708635c20b!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4Liq4LmI4LiH4LmA4Liq4Lij4Li04Lih4LmA4Lio4Lij4Lip4LiQ4LiB4Li04LiI4LiU4Li04LiI4Li04LiX4Lix4LilIOC4quC4suC4guC4suC4oOC4suC4hOC5g-C4leC5ieC4leC4reC4meC4muC4mQ!5e0!3m2!1sth!2sus!4v1617784347162!5m2!1sth!2sus"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
          "
          frameborder="0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>